export default __webpack_public_path__ + "static/media/loading4.66e3dcee.gif";